import React from 'react';
/**
 * <pre>
 * PrivacyManagement config.
 *
 * Summary of responsibilities:
 *
 *  - defines any commonly used config values specific to PrivacyManagement.
 * </pre>
 *
 * @memberof module:PrivacyManagement
 * @namespace
 *
 * @type {Object}
 */
const Config = {

  // The publicly visible name to use when exposing this apps api methods.
  publicName: 'PrivacyManagement',

  // The key to use when creating the root store using combineReducers.
  stateKey: 'privacymanagement',

};

export default Config;
